import axios from "axios";
import { getApiBaseUrl } from "../../apis/getApiBaseUrl";

const BASE_URL = getApiBaseUrl();

// Initialize Axios instance
const apiService = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// API Functions

// GET request
export const get = async (path, params = {}, { headers = {} } = {}) => {
  try {
    const response = await apiService.get(path, { params, headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// POST request
export const post = async (path, data = {}, { headers = {} } = {}) => {
  try {
    const response = await apiService.post(path, data, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// POST request with file upload
export const postWithFile = async (path, data = {}, { headers = {} } = {}) => {
  try {
    const response = await apiService.post(path, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...headers,
      },
      maxContentLength: 10 * 1024 * 1024, // 10MB max size
      maxBodyLength: 10 * 1024 * 1024,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// PUT request
export const put = async (path, data = {}, { headers = {} } = {}) => {
  try {
    const response = await apiService.put(path, data, { headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// DELETE request
export const del = async (path, data = {}, { headers = {} } = {}) => {
  try {
    const response = await apiService.delete(path, { data, headers });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// File upload function
export const upload = async (path, data = {}, { headers = {} } = {}) => {
  try {
    const response = await apiService.post(path, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        ...headers,
      },
      maxContentLength: 10 * 1024 * 1024, // 10MB max size
      maxBodyLength: 10 * 1024 * 1024,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// File download function
export const download = async (path, params = {}, { headers = {} } = {}) => {
  try {
    const response = await apiService.get(path, {
      responseType: "blob",
      params,
      headers,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Request Interceptor for Authorization
apiService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken") || sessionStorage.getItem("token");

    // Use a custom flag in the request config to skip Authorization
    if (token && !config.skipAuth) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor
apiService.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  }
);
